import { useQuery } from '@tanstack/react-query';
import DocumentLibrary from '../../views/DocumentLibrary';
import { useApiClients } from '../../client/api/useApiClient';
import { useSearchParams } from 'react-router';
import {
  DocumentLibraryControllerAddDocumentDocumentTypeEnum,
  GetDocumentLibraryResponseDto,
} from '@EHSNavigator/backend';

export default function DocumentLibraryPage() {
  const { DocumentLibraryApi } = useApiClients();
  const [searchParams] = useSearchParams();

  const page = searchParams.get('page') ?? 1;
  const searchQuery = searchParams.get('search') ?? '';
  const documentType = searchParams.get('documentType') ?? 'All';
  const limit = searchParams.get('limit') ?? 10;

  const query: any = {
    page: Number(page) || 1,
  };

  if (searchQuery) query.search = searchQuery;
  if (documentType) query.documentType = documentType;
  if (limit) query.limit = Number(limit);

  const { data, isLoading, isRefetching } = useQuery<
    GetDocumentLibraryResponseDto,
    Error,
    any
  >({
    queryKey: ['all-documents', page, searchQuery, documentType, Number(limit)],
    queryFn: async () => {
      const response =
        await DocumentLibraryApi.documentLibraryControllerGetAllDocuments({
          ...query,
        });
      return response?.data;
    },
  });

  const hasFilters = !!searchQuery || documentType !== 'All';

  const noDataMessage = hasFilters
    ? 'No items match your filters or search. Try using different keywords maybe.'
    : "You haven't added any document.";

  return (
    <div className="flex w-full flex-1 flex-col px-15 pt-14 pb-10 md:px-25 lg:pr-14 lg:pb-20 lg:pl-8">
      <DocumentLibrary
        params={{
          search: searchQuery,
          page: Number(page),
          documentType:
            documentType as DocumentLibraryControllerAddDocumentDocumentTypeEnum,
          limit: Number(limit),
        }}
        data={data}
        noDataMessage={noDataMessage}
        isLoading={isLoading || isRefetching}
      />
    </div>
  );
}
